import { useTranslation } from 'react-i18next'
import { Offer } from '../../../../domain/dtos/offer'
import { Period } from '../../../../domain/enums/period'
import { formatLocalNumber } from '../../../../domain/vos/format-local-number'
import { CardInfoBox } from '../../../components/card-info-box'
import { useGetInactiveSubscriptions } from '../../../hooks/use-get-inactive-subscriptions'
import { useRefetch } from '../../../hooks/use-refetch'
import { Loading } from './loading'

type InactiveSubscriptionsProps = {
  period: Period
  startDate: string
  endDate: string
  offerIds: string[]
  offers: Offer[]
  isLoading: boolean
}

export const InactiveSubscriptions = (props: InactiveSubscriptionsProps) => {
  const { period, startDate, endDate, offers, offerIds, isLoading } = props
  const { t } = useTranslation()

  const { data, isFetching, refetch } = useGetInactiveSubscriptions(
    { period, startDate, endDate, offers, offerIds },
    isLoading,
  )

  useRefetch({ period, startDate, endDate, offers, offerIds }, refetch)

  if (isFetching || isLoading) {
    return <Loading />
  }

  const getVariation = () => {
    return {
      indicator: data.indicator,
      status: data.status,
      description: `${data.percentage} ${t('variation', { previous: formatLocalNumber(data.previous) })}`,
    }
  }

  return (
    <CardInfoBox
      title={t('inactiveSubscriptions.title')}
      description={t('inactiveSubscriptions.description')}
      current={formatLocalNumber(data.current)}
      variation={getVariation()}
    />
  )
}
